import * as React from "react";

import { useEventCallback } from "./useEventCallback";

interface UseMutationObserverOptions extends MutationObserverInit {
  target: Node | null;
}

export function useMutationObserver(
  {
    target,
    childList = true,
    subtree = true,
    attributes,
    attributeFilter,
    attributeOldValue,
    characterData,
    characterDataOldValue,
  }: UseMutationObserverOptions,
  callback: MutationCallback,
): void {
  const callbackRef = useEventCallback(callback);

  React.useEffect(() => {
    if (!target) return;

    const observer = new MutationObserver(callbackRef);
    observer.observe(target, {
      childList,
      subtree,
      attributes,
      attributeFilter,
      attributeOldValue,
      characterData,
      characterDataOldValue,
    });

    return () => observer.disconnect();
  }, [
    target,
    childList,
    subtree,
    attributes,
    attributeFilter,
    attributeOldValue,
    characterData,
    characterDataOldValue,
    callbackRef,
  ]);
}
